import { useState } from 'react';
import { I18n } from '@/i18n/I18n';
import { useGlobalStore } from '../store/GlobalStore';
import { VeriformController } from '../controllers/veriformController';
import { downloadLinkFileFromS3 } from '../utils/downloadFileFromS3';

/**
 * Fetch a presigned URL for the Veriform Desktop installer and start the
 * download, surfacing failures as a toast.
 *
 * `isDownloading` covers the presign round trip only. The browser owns the
 * transfer once the link is clicked, so there is no progress to report after
 * that -- callers should treat this as "request in flight", not "download in
 * progress".
 */
export function useDesktopDownload() {
  const [isDownloading, setIsDownloading] = useState(false);
  const addErrorToast = useGlobalStore(state => state.addErrorToast);

  const download = async () => {
    setIsDownloading(true);
    try {
      const { presignedUrl } = await new VeriformController().gets3UrlForDesktopDownload();
      downloadLinkFileFromS3(presignedUrl);
    } catch {
      addErrorToast(I18n.get('failedToDownloadVeriformDesktop'));
    }
    setIsDownloading(false);
  };

  return { isDownloading, download };
}
